import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/AosFixe.jsx");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/components/ClientTransitionWrapper.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/Footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/forms/Header_inquiry.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/Header.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/InitEffects.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/InitReduxFromServer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/components/Loader.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastContainer"] */ "/opt/render/project/src/node_modules/react-toastify/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/public/css/new-style.css");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/public/css/style2.css");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/public/css/style-jay.css");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/swiper/swiper.css");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/swiper/modules/navigation.css");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/swiper/modules/pagination.css");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/swiper/modules/scrollbar.css");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/react-toastify/dist/ReactToastify.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/render/project/src/store/Providers.jsx");
